<template>
  <v-container fluid class="pa-0">
    <v-col v-for="(itemLote) in listaLotesFiltradaDataPlanta" :key="itemLote.idProgramacaoAbateAlocado">
      <v-layout class="card-periodo-preenchimento">
        <v-flex lg12>
          <CardItemLoteAlocadoCarregamento
            :itemLote="itemLote"
            :itemData="itemData"
            :itemPlanta="itemPlanta"
            @periodoChanged="periodoChanged"
          />
        </v-flex>
      </v-layout>
    </v-col>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex"

import CardItemLoteAlocadoCarregamento from "@/modules/programacaoAbate/components/CardItemLoteAlocadoCarregamento"

export default {
  name: "CardCarregamentoLoteColunm",
  components: {
    CardItemLoteAlocadoCarregamento,
  },
  props: {
    itemData: {
      type: Object,
      default: {},
    },
    itemPlanta: {
      type: Object,
      default: {},
    },
    listaLotesFiltradaDataPlanta: {
      type: Array,
    },
  },
  computed: {
    ...mapState("programacaoAbate", [
      "listaDatas",
      "listBatchsAllocated",
      "listCheckListAlocados",
    ]),
  },
  data() {
    return {}
  },
  methods: {
    ...mapActions("programacaoAbate", [
      "ActionLoadCheckList",
      "ActionLoadDistanciaPlantaAbateEstabelecimento",
    ]),
    periodoChanged() {
      this.$emit("forceRerender")
    },
  },
}
</script>

<style>

.text-card-periodo-preenchido {
  text-align: left;
  font: bold 12px Roboto;
  letter-spacing: 0px;
  color: #7b9596;
  opacity: 1;
}
</style>
